module.exports = __webpack_public_path__ + "img/exp_pin.669140c8.png";